export const CREATE_RESERVATION_REQUEST = "CREATE_RESERVATION_REQUEST";
export const CREATE_RESERVATION_SUCCESS = "CREATE_RESERVATION_SUCCESS";
export const CREATE_RESERVATION_FAIL = "CREATE_RESERVATION_FAIL";
export const CREATE_RESERVATION_RESET = "CREATE_RESERVATION_RESET";


export const ALL_RESERVATIONS_REQUEST = "ALL_RESERVATIONS_REQUEST";
export const ALL_RESERVATIONS_SUCCESS = "ALL_RESERVATIONS_SUCCESS";
export const ALL_RESERVATIONS_FAIL = "ALL_RESERVATIONS_FAIL";


export const UPDATE_RESERVATION_STATUS_REQUEST = "UPDATE_RESERVATION_STATUS_REQUEST";
export const UPDATE_RESERVATION_STATUS_SUCCESS = "UPDATE_RESERVATION_STATUS_SUCCESS";
export const UPDATE_RESERVATION_STATUS_RESET = "UPDATE_RESERVATION_STATUS_RESET";
export const UPDATE_RESERVATION_STATUS_FAIL = "UPDATE_RESERVATION_STATUS_FAIL";



export const SINGLE_RESERVATION_REQUEST = "SINGLE_RESERVATION_REQUEST";
export const SINGLE_RESERVATION_SUCCESS = "SINGLE_RESERVATION_SUCCESS";
export const SINGLE_RESERVATION_FAIL = "SINGLE_RESERVATION_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";
